import { useState } from 'react';
import api from '../api'; // Substitua por seu arquivo de configuração da API
import secureStorage from '../../utils/SecureStorage';

const useBuscaPerfil = () => {
  const [loading, setLoading] = useState(false);
  const [searchResults2, setSearchResults2] = useState([]);
  const [error, setError] = useState(null);
  const apiUrl1 = process.env.REACT_APP_API_BASE_18;

  const loadregistros2 = async (idrede, idLigacao) => {
    setLoading(true);
    try {
      const response = await api.get(`${apiUrl1}${idrede}&id_ligacao=${idLigacao}`);
      // Verifica se a propriedade data dentro de response está presente
      if (response.data) {
        // Atualiza o estado com os novos dados
        secureStorage.setItem("dataPrfil", JSON.stringify(response.data));
        setSearchResults2([response.data]); // Esta linha está correta
      } else {
        setError("Erro ao buscar cadastros. Veja o console para mais detalhes.");
        setSearchResults2([]); // Limpa os resultados anteriores
      }
    } catch (error) {
      setError("Erro ao buscar cadastros. Veja o console para mais detalhes.");
      setSearchResults2([]); // Limpa os resultados anteriores
    } finally {
      setLoading(false);
    }
  };


  return { loading, searchResults2, error, loadregistros2 };
};

export default useBuscaPerfil;
